<div class="landing-container">
    <div class="landing-content">
        <div class="landing-header">
            <app-guest-header *ngIf="headerFooterCMSData" [headerFooterCMSData]="headerFooterCMSData"></app-guest-header>
        </div>

        <div class="main-container">
            <div class="landing-carousel">
                <app-guest-carousel *ngIf="landingCMSData" [landingCMSData]="landingCMSData"></app-guest-carousel>
            </div>
    
            <div class="landing-choose-program">
                <app-choose-program *ngIf="landingCMSData" [landingCMSData]="landingCMSData"></app-choose-program>
            </div>
    
            <div class="landing-program-features">
                <app-program-features *ngIf="landingCMSData" [landingCMSData]="landingCMSData"></app-program-features>
            </div>
    
            <div class="landing-program-benefits">
                <app-program-benefits *ngIf="landingCMSData" [landingCMSData]="landingCMSData"></app-program-benefits>
            </div>
        </div>

        <div class="landing-footer">
            <app-guest-footer *ngIf="headerFooterCMSData" [headerFooterCMSData]="headerFooterCMSData"></app-guest-footer>
        </div>
    </div>
</div>